import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './LinkCell.scss';
import { FloorPlanShort } from 'api/encounters/types';
import { SignType } from 'api/InteractiveMap/types';

interface SignLinkCellProps {
  data: FloorPlanShort | null;
  icon: string;
  slug: string | undefined;
  sign_type?: SignType;
  enc_id: number;
}
const SignLinkCell: React.FC<SignLinkCellProps> = ({ data, icon, slug, sign_type, enc_id }) => {
  const { t } = useTranslation();

  const link = data
    ? `/object/interactive-map/${slug}/${data.slug}?encounter_zoom=${enc_id}`
    : `/object/interactive-map/${slug}?sign_add_id=${enc_id}&sign_type=${sign_type}`;
  const is_warning = !data;
  const title = data ? data?.title : t('TrapTables.NotOnPlan');

  return (
    <Link to={link} className={`link-cell-item ${is_warning ? 'bg-warning' : ''}`}>
      <div className="icon">
        <i className={`${icon} icon rounded-pill fs-14 me-1`} />
      </div>

      <div className="text w-100 d-flex align-items-center justify-content-center">
        <span>{title || 'None'}</span>
      </div>
    </Link>
  );
};

export default SignLinkCell;
